import React from 'react';
import { tokenizeLinks } from './linkTokens';

/** プレーンテキストを改行（<br>）付きの span 群へ変換する */
const renderTextLines = (text: string, keyPrefix: string): React.ReactNode[] => {
  const lines = text.split('\n');
  return lines.map((line, lineIndex) => (
    <span key={`${keyPrefix}-${lineIndex}`} className="whitespace-pre-wrap">
      {line}
      {lineIndex < lines.length - 1 && <br />}
    </span>
  ));
};

/**
 * テキスト内の Markdownリンク `[テキスト](href)` と生URLを自動的にリンク化する
 */
export const renderTextWithLinks = (
  text: string,
  className: string = 'leading-[1.7]'
): React.ReactNode[] => {
  const tokens = tokenizeLinks(text);

  // リンクを含まない通常テキストには装飾用 className を適用しない
  // （className はリンク（<a>）専用の装飾。通常文字まで色が付くのを防ぐ）
  if (!tokens.some((token) => token.type === 'link')) {
    return renderTextLines(text, 'text');
  }

  const parts: React.ReactNode[] = [];
  tokens.forEach((token, index) => {
    if (token.type === 'text') {
      parts.push(...renderTextLines(token.value, `text-${index}`));
      return;
    }

    parts.push(
      <a
        key={`url-${index}`}
        href={token.href}
        target="_blank"
        rel="noopener noreferrer"
        className={`break-all ${className}`}
      >
        {token.text}
      </a>
    );

    // 生URLの直後には従来どおり改行を入れてレイアウト崩れを防ぐ。
    // ただし末尾、または直後が改行で始まる場合は二重改行を避けてスキップ。
    // Markdownリンク（文中インライン）には改行を入れない。
    if (token.raw) {
      const next = tokens[index + 1];
      const nextStartsWithNewline = next?.type === 'text' && next.value.startsWith('\n');
      if (next && !nextStartsWithNewline) {
        parts.push(<br key={`br-after-${index}`} />);
      }
    }
  });

  return parts;
};
